import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectDetailsModal from "./ProjectDetailsModal";

const Projects = ({ resumeProjects, resumeBasicInfo }) => {
  const [modalShow, setModalShow] = useState(false);
  const [projectData, setProjectData] = useState({});

  const handleShowModal = (data) => {
    setProjectData(data);
    setModalShow(true);
  };

  if (!resumeProjects || !resumeBasicInfo) {
    return null;
  }

  return (
    <section id="portfolio" className="py-5 bg-light">
      <Container>
        <Row className="mb-5">
          <Col className="text-center">
            <h2 className="fw-bold">{resumeBasicInfo.section_name.projects}</h2>
            <hr
              className="mx-auto w-25"
              style={{ height: "3px", opacity: "1" }}
            />
          </Col>
        </Row>

        <Row>
          {resumeProjects.map((project, index) => (
            <Col sm={12} md={6} lg={4} key={index} className="mb-4">
              {/* Laptop frame */}
              <div
                className="d-flex flex-column align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => handleShowModal(project)}
              >
                {/* Laptop screen */}
                <div
                  className="bg-dark rounded-top p-2"
                  style={{
                    width: "100%",
                    transition: "transform 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "translateY(-5px)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  {/* Screen bezel with camera */}
                  <div className="d-flex justify-content-center align-items-center mb-2">
                    <div
                      className="bg-secondary rounded-circle"
                      style={{ width: "5px", height: "5px" }}
                    ></div>
                  </div>

                  {/* Screen content */}
                  <div className="bg-white rounded">
                    <div className="position-relative">
                      <img
                        src={project.images[0]}
                        alt={project.title}
                        className="w-100 rounded-top"
                        style={{ height: "180px", objectFit: "cover" }}
                      />
                    </div>
                    <div className="p-3 text-center">
                      <h5 className="mb-0">{project.title}</h5>
                    </div>
                  </div>
                </div>

                {/* Laptop base */}
                <div
                  className="bg-secondary rounded-bottom"
                  style={{
                    width: "70%",
                    height: "15px",
                    transformOrigin: "top center",
                  }}
                ></div>
              </div>
            </Col>
          ))}
        </Row>

        <ProjectDetailsModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          data={projectData}
        />
      </Container>
    </section>
  );
};

export default Projects;
